import script from "./VMwarePage.vue?vue&type=script&setup=true&lang=js"
export * from "./VMwarePage.vue?vue&type=script&setup=true&lang=js"

import "./VMwarePage.vue?vue&type=style&index=0&id=b6a1a536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6a1a536"]])

export default __exports__